import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import {
    Container,
    Typography,
    useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';

import { UserContext } from '../store/userContext';
import { SiteContext } from '../store/siteContext';
import StorageHeaderGrid from './RootStorageHeader';
import StorageList from './multiStorage/StorageList';
import Root from './singleStorage/Root';

const RootStorageComponent: React.FC = () => {
    const {
        getUsers,
        users,
    } = useContext(UserContext);
    const { sites } = useContext(SiteContext);

    const [selectedUserId] = useState<number | null>(null);
    const [selectedSiteId, setSelectedSiteId] = useState<number | null>(null);
    const [selectedStorageId, setSelectedStorageId] = useState<number | null>(null);
    const [selectedStorage, setSelectedStorage] = useState<StorageType | null>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const theme = useTheme();
    const { t } = useTranslation('nav');

    useEffect(() => {
        getUsers();
    }, [getUsers]);

    const selectedUser = users.find((u) => u.id === selectedUserId);
    const selectedSiteName =
        sites.find((site) => site.id === selectedSiteId)?.name || '';
    const selectedStorageName = selectedStorage?.name || '';

    const handleStorageSiteClick = (siteId: number) => {
        setSelectedSiteId(siteId);
        setSelectedStorageId(null);
        setSelectedStorage(null);
    };

    const handleStorageClick = (
        storageId: number | null,
        _storageName = '',
        storage: StorageType | null = null
    ) => {
        setSelectedStorageId(storageId);
        setSelectedStorage(storage);
    };

    const handleSiteNameClick = () => {
        setSelectedStorageId(null);
        setSelectedStorage(null);
    };

    const handleHomeClick = () => {
        setSelectedSiteId(null);
        setSelectedStorageId(null);
        setSelectedStorage(null);
    };

    return (
        <Container maxWidth="lg">
            <Typography
                align="left"
                variant="h3"
                sx={(theme) => ({
                    ...theme.typography.listTitle,
                    color: theme.palette.titleColor,
                    [theme.breakpoints.down('md')]: {
                        fontSize: '2.5rem',
                    },
                })}
            >
                Sites & Storages
            </Typography>
            <Grid container alignItems="stretch" sx={{ border: theme.palette.border }}>
                <StorageHeaderGrid
                    selectedUser={selectedUser}
                    selectedSiteName={selectedSiteName}
                    selectedStorageName={selectedStorageName}
                    onHomeClick={handleHomeClick}
                    onSiteNameClick={handleSiteNameClick}
                />

                {selectedStorageId && selectedStorage ? (
                    <Root storage={selectedStorage} />
                ) : (
                    <StorageList
                        selectedSiteId={selectedSiteId}
                        selectedStorageId={selectedStorageId}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSiteClick={handleStorageSiteClick}
                        onStorageClick={handleStorageClick}
                    />
                )}
            </Grid>
        </Container>
    );
};

export default RootStorageComponent;
